if (!customElements.get('osc-promo-week')) {
  customElements.define('osc-promo-week', class extends HTMLElement {
    connectedCallback() {
      this.checkExpiry = () => {
        clearTimeout(this.expiryTimer);
        const remaining = Number(this.dataset.cutoff) * 1000 - Date.now();
        this.hidden = !Number.isFinite(remaining) || remaining <= 0;
        if (!this.hidden) {
          this.expiryTimer = setTimeout(this.checkExpiry, Math.min(remaining, 2147483647));
        }
      };
      window.addEventListener('pageshow', this.checkExpiry);
      document.addEventListener('visibilitychange', this.checkExpiry);
      this.checkExpiry();
    }

    disconnectedCallback() {
      clearTimeout(this.expiryTimer);
      window.removeEventListener('pageshow', this.checkExpiry);
      document.removeEventListener('visibilitychange', this.checkExpiry);
    }
  });
}
